import { GET_END_SESSION_TICKET, GET_END_SESSION_TICKET_SUCCESS, GET_END_SESSION_TICKET_ERROR, GET_END_SESSION_TICKET_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetEndSessionTicket = (state = initialState, action) => {
  switch (action.type) {
    case GET_END_SESSION_TICKET:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_END_SESSION_TICKET_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_END_SESSION_TICKET_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_END_SESSION_TICKET_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetEndSessionTicket;
